var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.fv_atril_video ? 'lds-dual-ring-fv' : 'lds-dual-ring'})
}
var staticRenderFns = []

export { render, staticRenderFns }